import { defineMessages } from 'react-intl-next';

export const i18n: {
	salesforceStageFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	salesforceStageFilterLabel: {
		id: 'search-page.salesforce.filter.stage',
		defaultMessage: 'Stage',
		description: 'Label for filtering by Salesforce opportunity stage',
	},
});
